/**
 * 列表 keep-alive 下，详情抽屉再次打开时 priId 可能未变，需按当前 priId 重新拉详情。
 * 仅作用于带 infoDrawerVisible + priId + initDetailInfo 的 m-detail 类组件，不影响编辑页。
 */
export default {
  watch: {
    infoDrawerVisible(n) {
      if (!n) return;
      if (this.priId == null || this.priId === "") return;
      if (typeof this.initDetailInfo !== "function") return;

      if (this.InfoData !== undefined) {
        this.InfoData = Array.isArray(this.InfoData) ? [] : {};
      }
      this.initDetailInfo();
    },
  },
};
